export const BavStatusDTO = {
  VALID: 'Valid',
  INVALID: 'Invalid',
};

export const BankAccountHolderTypeDTO = {
  PERSONAL: 'personal',
  BUSINESS: 'business',
};

export const BankAccountTypeDTO = {
  SAVINGS: 'Savings',
  CURRENT_CHEQUE: 'Current Cheque Account',
};

export const BusinessRegistrationTypeDTO = {
  BUSINESS_REGISTRATION: 'Business Registration',
  RSA_ID: 'RSA ID',
};

export const DebitOrderDateDTO = {
  FIRST_DAY_OF_MONTH: 'First day of month',
  LAST_DAY_OF_MONTH: 'Last day of the month',
  DAY_7: '7',
  DAY_8: '8',
  DAY_9: '9',
  DAY_10: '10',
  DAY_11: '11',
  DAY_12: '12',
  DAY_13: '13',
  DAY_14: '14',
  DAY_15: '15',
  DAY_16: '16',
  DAY_17: '17',
  DAY_18: '18',
  DAY_19: '19',
  DAY_20: '20',
  DAY_21: '21',
  DAY_22: '22',
  DAY_23: '23',
  DAY_24: '24',
  DAY_25: '25',
  DAY_26: '26',
  DAY_27: '27',
  DAY_28: '28',
  DAY_29: '29',
  DAY_30: '30',
};
